import { isObject, instanceOfPrimitive } from "@perxis-auto/shared";
function instanceOfFilterPrimitive(object) {
  return isObject(object) && "value" in object && instanceOfPrimitive(object == null ? void 0 : object.value);
}
export {
  instanceOfFilterPrimitive
};
